import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldCode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShieldCode"><Path fillRule="evenodd" clipRule="evenodd" d="M21 5.34668V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13V5.34668L12 1.4082L21 5.34668ZM6.33594 12L9.75 15.4141L11.1641 14L9.16406 12L11.1641 10L9.75 8.58594L6.33594 12ZM12.8359 10L14.8359 12L12.8359 14L14.25 15.4141L17.6641 12L14.25 8.58594L12.8359 10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShieldCode;
